export default __webpack_public_path__ + "static/media/camera.654b78f2.svg";